import { atom } from 'jotai'

const countAtom = atom(0);

export default countAtom;


